import { render, staticRenderFns } from "./ArticleTiles.vue?vue&type=template&id=29497632&scoped=true"
import script from "./ArticleTiles.vue?vue&type=script&lang=js"
export * from "./ArticleTiles.vue?vue&type=script&lang=js"
import style0 from "./ArticleTiles.vue?vue&type=style&index=0&id=29497632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29497632",
  null
  
)

export default component.exports